import { useEffect } from "react";

const APP_VERSION = "1.0.1";

const VersionChecker = () => {
  useEffect(() => {
    const storedVersion = localStorage.getItem("app_version");

    if (storedVersion !== APP_VERSION) {
      console.log("App version changed. Reloading...");
      localStorage.setItem("app_version", APP_VERSION);
      window.location.reload();
    }
  }, []);

  return null;
};

export default VersionChecker;
